module.exports = __webpack_public_path__ + "static/media/0349_Medium.7ae616d9.jpg";